import React from 'react';
import {useSelector} from 'react-redux';
import _ from 'underscore';
import config from "../../config";
import Breadcrumb from "react-bootstrap/Breadcrumb";

const Breadcrumbs = () => {
    const mobile_small = useSelector((state) => state.appReducer.mobile_small);
    const product = useSelector((state) => state.shopifyReducer.product);
    if(!product){
        return null;
    }

    let collection = 'Items';
    const {tags, title} = product;
    const bc_collections = [
        'bc-filter-Accessories', 'bc-filter-Bags', 'bc-filter-Watches', 'bc-filter-Jewelry',
        'bc-filter-Shoes', 'bc-filter-Apparel'
    ];
    try {
        collection = _.find(tags, (tag) => {
            return _.indexOf(bc_collections, tag) !== -1;
        }).replace('bc-filter-', '');
    } catch (e){}

    return (
        <Breadcrumb
            as="div"
            className="rbg-breadcrumbs-container"
        >
            {!mobile_small &&
            <Breadcrumb.Item
                href={config.host_rebag}
            >
                Home
            </Breadcrumb.Item>
            }
            <Breadcrumb.Item
                href={`${config.host_rebag_shop}/collections/all-${collection.toLowerCase()}`}
            >
                {mobile_small &&
                <span className="icon icon-chevron-left"/>
                }
                All {collection}
            </Breadcrumb.Item>
            {!mobile_small &&
            <Breadcrumb.Item
                active
            >
                {title}
            </Breadcrumb.Item>
            }
        </Breadcrumb>
    )
}

export default Breadcrumbs;